<template>
  <div>
    <div class="container">
      <div class="mt-3">
        <b-card no-body>
          <b-tabs
            pills
            card
            lazy
          >
            <b-tab title="Member Info">
              <member-info
                :memberid="memberid"
                v-if="isFinishLoadMember"
              ></member-info>
              <b-card-text v-else>Loading Data..</b-card-text>
            </b-tab>
            <b-tab title="Visits">
              <member-visit
                :memberid="memberid"
                v-if="isFinishLoadMember"
              ></member-visit>
              <b-card-text v-else>Loading Data..</b-card-text>
            </b-tab>
            <b-tab title="Packages">
              <member-package
                :memberid="memberid"
                v-if="isFinishLoadMember"
              ></member-package>
              <b-card-text v-else>Loading Data..</b-card-text>
            </b-tab>
            <b-tab title="Purchase">
              <member-purchase
                :memberid="memberid"
                v-if="isFinishLoadMember"
              ></member-purchase>
              <b-card-text v-else>Loading Data..</b-card-text>
            </b-tab>
            <b-tab title="Subscription">
              <member-subscription
                :memberid="memberid"
                v-if="isFinishLoadMember"
              ></member-subscription>
              <b-card-text v-else>Loading Data..</b-card-text>
            </b-tab>
            <!--
            <b-tab title="Test">
              <test v-if="isFinishLoadMember"></test>
              <b-card-text v-else>Loading Data..</b-card-text>
            </b-tab>-->
          </b-tabs>
        </b-card>
      </div>
    </div>
    <!-- ./container -->
  </div>
</template>
<script>
import MemberInfo from "./MemberInfo.vue";
import MemberVisit from "./MemberVisit.vue";
import MemberPackage from "./MemberPackage.vue";
import MemberPurchase from "./MemberPurchase.vue";
import MemberSubscription from "./MemberSubscription.vue";

//import Test from "./Test.vue";
export default {
  components: {
    MemberInfo,
    MemberVisit,
    MemberPackage,
    MemberPurchase,
    MemberSubscription
    //Test
  },
  data() {
    return {
      memberid: this.$route.params.id,
      loading: false,
      member: null,
      isFinishLoadMember: true
    };
  },
  mounted() {
    //console.log("x" + this.$route.params.cardId);
    if (this.$route.params.id != null) {
      //console.log("x2");
      //localStorage.setItem("currentCardID", this.$route.params.id);
      //this.getMember();
    } else {
      this.$router.push({ name: "Members" });
    }
  },
  methods: {
    async getMember() {
      //console.log(this.cardID);
      /* await axios
        .get("/api/members/findinfo", {
          params: {
            cardid: this.cardID,
          },
        })
        .then((response) => {
          //console.log(response.data);
          this.member = response.data[0];

          this.loading = false;
          this.isFinishLoadMember = true;
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push({ name: "Members" });
          }
        }); */
    }
  }
};
</script>
